<template>
  <div
    class="gw_tbbox"
    :data-tst="`${tstPrefix}_tbbox`"
  >
    <SimpleTabs
      class="gw_tbbox_tabs gtabs_simple_small"
      :class="{ 'scroll-right-overlay': hasScrollRight }"
      :scrollToActiveTab="scrollToActiveTab"
      :hasDragscroll="hasDragscroll"
      :options="l_options"
      :value="l_tab"
      :idKey="idKey"
      style="
        --scrlr-z-index: 1;
        --clr-scrl-back: var(--clr-tbbox-tab-back);
        --clr-tab-hover-back: var(--clr-tbbox-tab-hover-back);
        --clr-tab-active-back: var(--clr-tbbox-tab-active-back);
      "
      :style="tabsStyle"
      @click="handleClick"
      @touchstart="e => $emit('touchstart', e)"
      @mousedown="e => $emit('mousedown', e)"
    >
      <template #default="{ item }">
        <slot
          :name="hasNamedTabSlot ? `tab_${item[idKey] || item}` : 'tab'"
          :item="item"
          :value="l_tab"
        >
          {{ $t(`${translatePath}.${item[idKey] || item}`) }}
        </slot>
      </template>
      <template #inner_after>
        <slot name="inner_after" />
      </template>
      <template #after>
        <slot name="tabs_after" />
        <div
          v-if="hasMinify"
          class="gw_btn gw_tbbox_minify"
          style="--height: calc(100% - 2px); top: 1px"
          @click="minified = !minified"
        >
          <div
            class="mdi mdi-fullscreen"
            :class="minified ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"
          ></div>
        </div>
      </template>
    </SimpleTabs>
    <div
      v-show="hasMinify ? !minified : true"
      class="gw_tbbox_content"
    >
      <div
        class="gw_tbbox_content_inner large-scroll-track"
        :data-tst="`${tstPrefix}_tbboxcontent`"
      >
        <slot :tab="l_tab" />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTabs from '@/components/AppBar/SimpleTabs'
import { allSwitchers } from '@/store/switchers/switchers'

export default {
  name: 'TabBox',
  components: {
    SimpleTabs,
  },
  props: {
    swKey: { default: '' },
    idKey: { default: 'payload' },
    translatePath: { default: 'tabs' },
    options: Array,
    tab: String,
    tabsStyle: String,
    hasMinify: Boolean,
    hasNamedTabSlot: Boolean,
    scrollToActiveTab: Boolean,
    hasDragscroll: Boolean,
    hasScrollRight: { type: Boolean, default: true },
    tstPrefix: { default: () => 'tbbox' },
  },
  emits: ['touchstart', 'mousedown', 'update:switcher', 'click'],
  data() {
    return {
      ll_tab: '',
      minified: false,
    }
  },
  methods: {
    handleClick(itemOrId) {
      if (this.minified) {
        this.minified = false
      }
      if (this.swKey) {
        this.$store.dispatch('switchers_set_item', {
          key: this.swKey,
          item: itemOrId,
        })
        this.$emit('update:switcher', itemOrId)
        this.$emit('click', itemOrId)
        return
      }
      if (this.tab) {
        this.$emit('click', itemOrId)
        return
      }
      this.ll_tab = itemOrId
      this.$emit('click', itemOrId)
    },
  },
  computed: {
    l_tab() {
      return this.minified
        ? ''
        : this.$store.getters[this.swKey] || this.tab || this.ll_tab || this.l_options[0]
    },
    l_options() {
      return this.options || allSwitchers()[this.swKey]
    },
  },
}
</script>
<style lang="scss" scoped>
.gw_tbbox {
  --clr-tbbox-tab-back: var(--clr-black-0);
  --tbbox-content-clr-back: var(--clr-black-1);
  --tbbox-content-max-height: 100%;
  --tbbox-content-min-height: 0px;

  --tbbox-overflow-y: auto;
  --tbbox-overflow-x: hidden;

  --clr-tbbox-tab-hover-back: var(--tbbox-content-clr-back);
  --clr-tbbox-tab-active-back: var(--tbbox-content-clr-back);

  --tbbox-content-padding: 0.5rem;
  --tbbox-content-inner-padding: 0;

  --tbbox-content-radius: 6px;

  --z-index-tbbox-content: 1;
  // use for big radius like 16px+ to keep inner radius symetric
  // --tbbox-inner-radius_optimal: calc(
  //   var(--tbbox-content-radius) - var(--tbbox-content-padding)
  // );
  // --tbbox-inner-radius: clamp(
  //   4px,
  //   var(--tbbox-inner-radius_optimal),
  //   var(--tbbox-inner-radius_optimal)
  // );
  --tbbox-inner-radius: 4px;

  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  z-index: 1;
  &:hover {
    z-index: 2;
    // z-index: 3;
  }
  &_minify {
    position: absolute;
    right: 0;
    // top: 0.125rem;
    z-index: 4;
  }
  &_tabs {
    // z-index: 2;
    z-index: 2;
  }
  &_content {
    z-index: var(--z-index-tbbox-content);
    &:hover {
      z-index: 3;
    }
    position: relative;
    display: flex;
    flex: 1;
    min-width: 0;
    min-height: var(--tbbox-content-min-height);
    background: var(--tbbox-content-clr-back);
    padding: var(--tbbox-content-padding);
    // padding: var(--tbbox-content-padding) 0 var(--tbbox-content-padding)
    // var(--tbbox-content-padding);
    border-radius: var(--tbbox-content-radius);
    max-height: var(--tbbox-content-max-height);
    &_inner {
      // background: grey;
      overflow-y: var(--tbbox-overflow-y);
      overflow-x: var(--tbbox-overflow-x);
      padding: var(--tbbox-content-inner-padding);
      // padding-right: var(--tbbox-content-padding);
      display: flex;
      min-height: 0;
      min-width: 0;
      flex: 1;
      position: relative;
      z-index: 2;
      border-radius: var(--tbbox-inner-radius);
    }
  }
}
</style>
